import { ONGLET_EMPLOYEUR, ONGLET_FORMATION } from "../shared"

export const OngletsCapp = [ONGLET_EMPLOYEUR, 'Apprenti', 'Contrat', ONGLET_FORMATION] as const
export type OngletCapp = (typeof OngletsCapp)[number]

export const OngletsCappLibellés: Record<OngletCapp, string> = {
  Employeur: 'Employeur',
  Apprenti: 'Apprenti',
  Contrat: 'Contrat',
  Formation: 'Formation',
}
